/**
 * A utility class providing a set of static methods for various tools and utilities.
 */
export class Tools {
    /**
     * Generates a short unique hash using a random 32-bit unsigned integer and converts it to a base-36 string.
     *
     * @return {string} A short hash string derived from a random 32-bit unsigned integer.
     */
    static generateShortHash() {
        return crypto.getRandomValues(new Uint32Array(1))[0].toString(36);
    }

    /**
     * Checks if the given object is a class.
     *
     * @param {any} object - The object to check.
     * @return {boolean} Returns true if the object is a class, otherwise false.
     */
    static isClass(object) {
        return typeof object === 'function' &&
            typeof object.prototype === 'object' &&
            /^class\s/.test(object.toString());
    }
}
